import Vue from 'vue';
import Router from 'vue-router';
import verifyToken from './middleware/verifyToken';

Vue.use(Router);

export default new Router({
  base: process.env.BASE_URL,
  routes:[
    //index or dashboard
    {
      path: '/',
      redirect: '/supporters'
    },
    //login
    {
      path: '/login',
      name: 'login',
      meta: { title: 'Login' },
      component: () => import('@/modules/Login'),
    },
    //user
    {
      path: '/users',
      component: () => import('@/layouts/Index'),
      beforeEnter: verifyToken,
      children: [
        // List users
        {
          name: 'user-list',
          path: '',
          meta: { title: 'User List' },
          component: () => import('@/modules/user/views/list'),
        },
        // Create user
        {
          name: 'user-create',
          path: 'create',
          meta: { title: 'Create User' },
          component: () => import('@/modules/user/views/create'),
        },
        // View user
        {
          name: 'user-view',
          path: ':id',
          meta: { title: 'View User' },
          component: () => import('@/modules/user/views/view'),
        },
        // Edit user
        {
          name: 'user-edit',
          path: ':id/edit',
          meta: { title: 'Edit User' },
          component: () => import('@/modules/user/views/edit'),
        },
        // Edit user
        {
          name: 'user-edit-password',
          path: ':id/edit/password',
          meta: { title: 'Edit User Password' },
          component: () => import('@/modules/user/views/edit.password'),
        },
      ],
    },
    //role
    {
      path: '/roles',
      component: () => import('@/layouts/Index'),
      beforeEnter: verifyToken,
      children: [
        // List roles
        {
          name: 'role-list',
          path: '',
          meta: { title: 'Role List' },
          component: () => import('@/modules/role/views/list'),
        },
        // Create role
        {
          name: 'role-create',
          path: 'create',
          meta: { title: 'Create Role' },
          component: () => import('@/modules/role/views/create'),
        },
        // View role
        {
          name: 'role-view',
          path: ':id',
          meta: { title: 'View Role' },
          component: () => import('@/modules/role/views/view'),
        },
        // Edit role
        {
          name: 'role-edit',
          path: ':id/edit',
          meta: { title: 'Edit Role' },
          component: () => import('@/modules/role/views/edit'),
        },
      ],
    },
    //customer
    {
      path: '/customers',
      component: () => import('@/layouts/Index'),
      beforeEnter: verifyToken,
      children: [
        // List customers
        {
          name: 'customer-list',
          path: '',
          meta: { title: 'Customer List' },
          component: () => import('@/modules/customer/views/list'),
        },
        // Create customer
        {
          name: 'customer-create',
          path: 'create',
          meta: { title: 'Create Customer' },
          component: () => import('@/modules/customer/views/create'),
        },
        // View customer
        {
          name: 'customer-view',
          path: ':id',
          meta: { title: 'View Customer' },
          component: () => import('@/modules/customer/views/view'),
        },
        // Edit customer
        {
          name: 'customer-edit',
          path: ':id/edit',
          meta: { title: 'Edit Customer' },
          component: () => import('@/modules/customer/views/edit'),
        },
      ],
    },
    //address
    {
      path: '/addresses',
      component: () => import('@/layouts/Index'),
      beforeEnter: verifyToken,
      children: [
        // List addresses
        {
          name: 'address-list',
          path: '',
          meta: { title: 'Address List' },
          component: () => import('@/modules/address/views/list'),
        },
        // Create address
        {
          name: 'address-create',
          path: 'create',
          meta: { title: 'Create Address' },
          component: () => import('@/modules/address/views/create'),
        },
        // View address
        {
          name: 'address-view',
          path: ':id',
          meta: { title: 'View Address' },
          component: () => import('@/modules/address/views/view'),
        },
        // Edit address
        {
          name: 'address-edit',
          path: ':id/edit',
          meta: { title: 'Edit Address' },
          component: () => import('@/modules/address/views/edit'),
        },
      ],
    },
    //request-helpers
    {
      path: '/request-helpers',
      component: () => import('@/layouts/Index'),
      beforeEnter: verifyToken,
      children: [
        // List request-helpers type maid
        {
          name: 'request-helper-maid-list',
          path: 'maid',
          meta: { title: 'Request Helper List' },
          component: () => import('@/modules/request-helper/views/maid-list'),
        },
        // List request-helpers type driver
        {
          name: 'request-helper-driver-list',
          path: 'driver',
          meta: { title: 'Request Helper List' },
          component: () => import('@/modules/request-helper/views/driver-list'),
        },
        // Edit request-helper
        {
          name: 'request-helper-edit',
          path: ':id/edit',
          meta: { title: 'Edit Request Helper' },
          component: () => import('@/modules/request-helper/views/edit'),
        },
      ],
    },
    //request-helpers status
    {
      path: '/request-helper-status',
      component: () => import('@/layouts/Index'),
      beforeEnter: verifyToken,
      children: [
        // List request-helpers
        {
          name: 'request-helper-status-list',
          path: '',
          meta: { title: 'Request Helper Status List' },
          component: () => import('@/modules/request-helper-status/views/list'),
        },
        // Create request-helper
        {
          name: 'request-helper-status-create',
          path: 'create',
          meta: { title: 'Create Request Helper Status' },
          component: () => import('@/modules/request-helper-status/views/create'),
        },
        // View request-helper
        {
          name: 'request-helper-status-view',
          path: ':id',
          meta: { title: 'View Request Helper Status' },
          component: () => import('@/modules/request-helper-status/views/view'),
        },
        // Edit request-helper
        {
          name: 'request-helper-status-edit',
          path: ':id/edit',
          meta: { title: 'Edit Request Helper Status' },
          component: () => import('@/modules/request-helper-status/views/edit'),
        },
      ],
    },
    //supporter
    {
      path: '/supporters',
      component: () => import('@/layouts/Index'),
      beforeEnter: verifyToken,
      children: [
        // List supporters
        {
          name: 'supporter-list',
          path: '',
          meta: { title: 'Supporter List' },
          component: () => import('@/modules/supporter/views/list')
        },
        // Create supporter
        {
          name: 'supporter-create',
          path: 'create',
          meta: { title: 'Create Supporter' },
          component: () => import('@/modules/supporter/views/create'),
        },
        // View supporter
        {
          name: 'supporter-view',
          path: ':id',
          meta: { title: 'View Supporter' },
          component: () => import('@/modules/supporter/views/view'),
        },
        // Edit supporter
        {
          name: 'supporter-edit',
          path: ':id/edit',
          meta: { title: 'Edit Supporter' },
          component: () => import('@/modules/supporter/views/edit'),
        },
      ],
    },

    //margeting
    //banner
    {
      name: 'banner-list',
      path: '/banners',
      meta: { title: 'Banner List' },
      component: () => import('@/modules/banner/views/index')
    },

    //belows are for biz
    //cleaning supply
    {
      path: '/cleaning-supplies',
      component: () => import('@/layouts/Index'),
      beforeEnter: verifyToken,
      children: [
        // List Cleaning-supply
        {
          name: 'cleaning-supply-list',
          path: '',
          meta: { title: 'Cleaning Supply List' },
          component: () => import('@/modules/cleaning-supply/views/list'),
        },
        // Create Cleaning-supply
        {
          name: 'cleaning-supply-create',
          path: 'create',
          meta: { title: 'New Cleaning Supply' },
          component: () => import('@/modules/cleaning-supply/views/create'),
        },
        // View Cleaning-supply
        {
          name: 'cleaning-supply-view',
          path: ':id',
          meta: { title: 'Cleaning Supply' },
          component: () => import('@/modules/cleaning-supply/views/view'),
        },
        // Edit Cleaning-supply
        {
          name: 'cleaning-supply-edit',
          path: ':id/edit',
          meta: { title: 'Edit Cleaning Supply' },
          component: () => import('@/modules/cleaning-supply/views/edit'),
        },
      ],
    },
    //customer supply
    {
      path: '/customer-supplies',
      component: () => import('@/layouts/Index'),
      beforeEnter: verifyToken,
      children: [
        // List customer-supply
        {
          name: 'customer-supply-list',
          path: '',
          meta: { title: 'Customer Supply List' },
          component: () => import('@/modules/customer-supply/views/list'),
        },
        // Create customer-supply
        {
          name: 'customer-supply-create',
          path: 'create',
          meta: { title: 'New Customer Supply' },
          component: () => import('@/modules/customer-supply/views/create'),
        },
        // View customer-supply
        {
          name: 'customer-supply-view',
          path: ':id',
          meta: { title: 'Customer Supply' },
          component: () => import('@/modules/customer-supply/views/view'),
        },
        // Edit Customer-supply
        {
          name: 'customer-supply-edit',
          path: ':id/edit',
          meta: { title: 'Edit Customer Supply' },
          component: () => import('@/modules/customer-supply/views/edit'),
        },
      ],
    },
    //supplier
    {
      path: '/suppliers',
      component: () => import('@/layouts/Index'),
      beforeEnter: verifyToken,
      children: [
        // List Supplier
        {
          name: 'supplier-list',
          path: '',
          meta: { title: 'Supplier List' },
          component: () => import('@/modules/supplier/views/list'),
        },
        // Create Supplier
        {
          name: 'supplier-create',
          path: 'create',
          meta: { title: 'New Supplier' },
          component: () => import('@/modules/supplier/views/create'),
        },
        // View Supply
        {
          name: 'supplier-view',
          path: ':id',
          meta: { title: 'Supplier' },
          component: () => import('@/modules/supplier/views/view'),
        },
        // Edit Supplier
        {
          name: 'supplier-edit',
          path: ':id/edit',
          meta: { title: 'Edit Supplier' },
          component: () => import('@/modules/supplier/views/edit'),
        },
      ],
    },
    //biz customer
    {
      path: '/biz-customers',
      component: () => import('@/layouts/Index'),
      beforeEnter: verifyToken,
      children: [
        // List Biz Customer
        {
          name: 'biz-customer-list',
          path: '',
          meta: { title: 'Biz Customer List' },
          component: () => import('@/modules/biz-customer/views/list'),
        },
        // Create Biz Customer
        {
          name: 'biz-customer-create',
          path: 'create',
          meta: { title: 'New Biz Customer' },
          component: () => import('@/modules/biz-customer/views/create'),
        },
        // View Biz Customer
        {
          name: 'biz-customer-view',
          path: ':id',
          meta: { title: 'Biz Customer' },
          component: () => import('@/modules/biz-customer/views/view'),
        },
        // Edit Biz Customer
        {
          name: 'biz-customer-edit',
          path: ':id/edit',
          meta: { title: 'Edit Biz Customer' },
          component: () => import('@/modules/biz-customer/views/edit'),
        },
      ],
    },

    //admin
    //admin profile
    {
      path: '/profile',
      component: () => import('@/layouts/Index'),
      beforeEnter: verifyToken,
      children: [
        {
          name: 'profile',
          path: '',
          meta: { title: 'Profile' },
          component: () => import('@/modules/profile/views/edit'),
        },
        {
          name: 'profile-password',
          path: 'password',
          meta: { title: 'Update password' },
          component: () => import('@/modules/profile/views/password.edit')
        }
      ]
    },
    {
      name: 'request-statistics',
      path: '/request-statistics',
      meta: { title: 'Request Statistics' },
      component: () => import('@/modules/request-helper/views/request-statistics')
    }
  ],
})